import { backofficeCommandURL, sec } from "../config";
import { postAsync } from "./ajax";

type CommandResponse = {
  message:string,
  command:any,
  data:any
}

export const PostToBackoffice = async (path: string, payload:any): Promise<CommandResponse> => {
  const url = `${backofficeCommandURL()}/${path}`

  console.info('Posting', path, payload);

  return sec.getAccessTokenSilently()
  .then(token => postAsync(url, JSON.stringify(payload), token))
  .then(r => {

    if (!r.ok)
      throw new Error(`Error posting command: ${r.status}`)

    return r.json()
  })
  .then(json => {
    console.log('response', json)
    return json;
  })
  .then(data => data as CommandResponse)
}